module.exports = __webpack_public_path__ + "assets/1eaa40208ef490d2462068c761bd13fe.svg";